import * as React from "react"
import { useState } from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import HomePageTop from '../components/HomePageTop'
import CommunityBlockLink from '../components/communityBlockLink'
import McKinleyApartmentsBlock from '../components/mckApartments'
import Benefits from '../components/benefits'
import McKinleyLivingBlogBlock from '../components/mckLivingBlog'
import FeaturedCommunities from '../components/featuredCommunities'
import McKRepresents from '../components/mckRepresents'
import McKinleyNewsBlock from '../components/mckNews'
import CorporateFooter from '../components/corporateFooter'
import FeaturedUnitsHome from '../components/FeaturedUnitsHome'
import "./mckstyles.scss"

const IndexPage = () => {

  const data = useStaticQuery(graphql`
    query {
        contentfulCorporate {
            annArborBackground {
              gatsbyImageData
            }
            orlandoBackground {
              gatsbyImageData
            }
            corporateBanner {
              gatsbyImageData
            }
      }
    }
    `
  )
  const a2image = getImage(data.contentfulCorporate.annArborBackground.gatsbyImageData)
  const oimage = getImage(data.contentfulCorporate.orlandoBackground.gatsbyImageData)
  const bimage = getImage(data.contentfulCorporate.corporateBanner.gatsbyImageData)
  const [selectedCitySlug, setSelectedCitySlug] = useState(null)
  return (
        <main>
            <HomePageTop image={bimage.images.fallback.src} onLocationChange={(citySlug)=>setSelectedCitySlug(citySlug)} />
            <br />
            <FeaturedUnitsHome citySlugFilter={selectedCitySlug} />
            <br />
            <div className="container" style={{marginTop:'10vh'}}>
                <div className="columns">
                    <div className="column">
                        <CommunityBlockLink title="Ann Arbor / Ypsilanti" path="/apartments/michigan/ann-arbor/" image={a2image.images.fallback.src} />
                    </div>
                    <div className="column">
                        <CommunityBlockLink title="Orlando / Winter Park" path="/apartments/florida/orlando/" image={oimage.images.fallback.src} />
                    </div>
                </div>
            </div>
            <McKinleyApartmentsBlock />
            <Benefits />
            <McKinleyLivingBlogBlock />
            <McKRepresents />
            <McKinleyNewsBlock />
            <FeaturedCommunities />
            <CorporateFooter />
        </main>
  )
}

export default IndexPage

export const Head = () => <><title>McKinley Apartments and Properties</title><meta name="description" content="McKinley has been proudly serving residents and our apartment communities in Southeast Michigan and Central Florida." /></>
